import React, { useEffect, useState } from 'react';

const SidebarOverlay = ({ isVisible, onClose }) => {
  const [opacity, setOpacity] = useState(0);
  
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => setOpacity(1), 10);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [isVisible]);
  
  if (!isVisible) return null;
  
  return (
    <div 
      className="fixed inset-0 bg-black z-30 transition-opacity duration-300 ease-in-out"
      style={{ opacity: opacity * 0.4 }}
      onClick={onClose}
    />
  );
};

export default SidebarOverlay; 